import React from 'react';
import DatePicker from '../shared/DatePicker';
import { getDateLimits } from '../onboardingQuestions';

interface StepProps {
  answer: any;
  onAnswer: (value: any) => void;
  answers: Record<string, any>;
}

const DateOfBirthStep: React.FC<StepProps> = ({ answer, onAnswer }) => {
  const limits = getDateLimits('date_of_birth');

  return (
    <DatePicker
      value={answer || null}
      onChange={onAnswer}
      min={limits.min}
      max={limits.max}
      defaultView="max"
    />
  );
};

export default DateOfBirthStep;
